module.exports = __webpack_public_path__ + "img/微信3.d0d8c3c.png";